import React, { useEffect, useState } from 'react';

import { Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import TableFooter from '../../components/common/TableFooter';
import ResourcesHeader from '../../components/resources/ResourcesHeader';
import ResourcesList from '../../components/resources/ResourcesList';
import { ACTIONS } from '../../constants/logs';
import { WorkspaceProductType } from '../../models/Workspace';
import LogService from '../../services/log.service';
import { launchAppCreatorMode } from '../../utils/resources';
import useBlocRefHook from '../../utils/useBlocRef.hook';

const useStyles = makeStyles(() => ({
  imagePaper: {
    backgroundColor: 'transparent',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
}));

export default () => {
  const blocRef = useBlocRefHook('resourcesBloc');
  const [materials, setMaterials] = useState([]);
  const [criteria, setCriteria] = useState(blocRef.current.criteria$.getValue());
  const [materialCount, setMaterialCount] = useState(0);
  const [loadingResourceInfo, setLoadingResourceInfo] = useState();
  const [userDetails, setUserDetails] = useState({});
  const classes = useStyles();

  useEffect(() => {
    const materialsSub = blocRef.current.materials$.subscribe(setMaterials);
    const criteriaSub = blocRef.current.criteria$.subscribe(setCriteria);
    const countSub = blocRef.current.materialCount$.subscribe(setMaterialCount);
    const resourceUpdateSub = blocRef.current.listenToResourceUpdate().subscribe();
    const loadingResourceInfoSub = blocRef.current.loadingResourceInfo$.subscribe(setLoadingResourceInfo);
    const userDetailsSub = blocRef.current.userDetails$.subscribe(setUserDetails);

    return () => {
      materialsSub.unsubscribe();
      criteriaSub.unsubscribe();
      countSub.unsubscribe();
      resourceUpdateSub.unsubscribe();
      loadingResourceInfoSub.unsubscribe();
      userDetailsSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddResource = () => blocRef.current.openAddResource();
  const handleCriteriaChange = (_criteria) => blocRef.current.updateCriteria(_criteria);
  const handleDeleteMaterial = (material) => blocRef.current.deleteMaterial(material);
  const handleEditMaterial = (material) => blocRef.current.openEditResource(material);
  const handleViewMaterial = (material) => blocRef.current.openViewer(material, { paper: classes.imagePaper });
  const handleRefresh = () => blocRef.current.refreshCriteria();
  const handleCreatorMode = () => {
    new LogService().create({
      action: ACTIONS.RESOURCE_RECORDER_OPENED,
    });

    launchAppCreatorMode();
  };

  const isTechQA = userDetails?.workspace?.productType === WorkspaceProductType.TechQA.value;
  const isCreatorMode = userDetails?.workspace?.creatorMode || isTechQA || false;
  const isSuperAdmin = userDetails?.role === 'super-admin' || false;

  return (
    <Grid container component={Container} style={{ display: 'flex', marginTop: '30px', width: '100vw' }}>
      <Grid item xs={12}>
        <ResourcesHeader
          onCriteriaChange={handleCriteriaChange}
          onCreatorMode={handleCreatorMode}
          onAddResource={handleAddResource}
          newResources$={blocRef.current.newResources$}
          onRefresh={handleRefresh}
          isCreatorMode={isCreatorMode}
          isSuperAdmin={isSuperAdmin}
          disableTemplateView={isTechQA}
        />
      </Grid>

      <Grid item xs={12} className="mt-1">
        <ResourcesList
          onViewMaterial={handleViewMaterial}
          onEditMaterial={handleEditMaterial}
          materials={materials}
          onDeleteMaterial={handleDeleteMaterial}
          loadingResourceInfo={loadingResourceInfo}
          isTechQA={isTechQA}
        />
      </Grid>

      <Grid item xs={12} style={{ paddingBottom: '16px' }}>
        <TableFooter count={materialCount} page={criteria.page} rowsPerPage={criteria.limit} changePage={(page) => handleCriteriaChange({ page })} />
      </Grid>
    </Grid>
  );
};
